const Mock = require('mockjs')
const Random = Mock.Random

const empList = [
	{
		empName: '颜景兵',
		empIdNo: '370404198708235719',
	},
	{
		empName: '颜增增',
		empIdNo: '370404199010055710',
		workType: '0',
	},
	{
		empName: '孙中华',
		empIdNo: '370404196510105733',
		workType: '0',
	},
	{
		empName: '孙中利',
		empIdNo: '370404196810105719',
		workType: '0',
	},
	{
		empName: '鹿发起',
		empIdNo: '370402198703153658',
		workType: '0',
	},
	{
		empName: '张普',
		empIdNo: '320326197509021338',
		workType: '0',
	},
	{
		empName: '杨希亚',
		empIdNo: '320382198303119415',
		workType: '0',
	},
	{
		empName: '杨猛',
		empIdNo: '320324198406214737',
		workType: '0',
	},
	{
		empName: '陆敬征',
		empIdNo: '320382198301059439',
		workType: '0',
	},
	{
		empName: '朱曾贤',
		empIdNo: '320324196904200419',
		workType: '0',
	},
	{
		empName: '王亮',
		empIdNo: '32038219851007941X',
		workType: '0',
	},
	{
		empName: '解强',
		empIdNo: '320382199506035910',
		workType: '0',
	},
	{
		empName: '解祥圣',
		empIdNo: '320325197103075997',
		workType: '0',
	},
	{
		empName: '郁卫洲',
		empIdNo: '320924198712029030',
		workType: '0',
	},
	{
		empName: '杨昌兵',
		empIdNo: '522227196901240055',
		workType: '0',
	},
	{
		empName: '陈贵珍',
		empIdNo: '320911197811204926',
		workType: '0',
	},
	{
		empName: '谢渊',
		empIdNo: '431125198601123111',
		workType: '0',
	},
	{
		empName: '竺春山',
		empIdNo: '320911197504284911',
		workType: '0',
	},
	{
		empName: '朱仁超',
		empIdNo: '320924197011014878',
		workType: '0',
	},
	{
		empName: '严法仨',
		empIdNo: '32092419720501485X',
		workType: '0',
	},
	{
		empName: '吕开林',
		empIdNo: '32092419650529481X',
		workType: '0',
	},
	{
		empName: '张宏涛',
		empIdNo: '32128119860629261X',
		workType: '0',
	},
	{
		empName: '邬晓庆',
		empIdNo: '320283198501316517',
		workType: '0',
	},
	{
		empName: '郭清磊',
		empIdNo: '410621197104183036',
		workType: '0',
	},
	{
		empName: '陈欢',
		empIdNo: '522126197104112037',
		workType: '0',
	},
	{
		empName: '陈海军',
		empIdNo: '320922198308153619',
		workType: '0',
	},
	{
		empName: '高善冬',
		empIdNo: '320922198212273659',
		workType: '0',
	},
	{
		empName: '张从元',
		empIdNo: '320922198112095752',
		workType: '0',
	},
	{
		empName: '戴益成',
		empIdNo: '320922200302225714',
		workType: '0',
	},
	{
		empName: '周兆祥',
		empIdNo: '320922197011235790',
		workType: '0',
	},
	{
		empName: '杨茂明',
		empIdNo: '512926196909244771',
		workType: '0',
	},
]

const unitList = [
	{
		unit_name: '余姚恒须光伏科技有限公司',
		unit_code: '91330281MA7CB59M1B',
		area_code: '330281',
		bus_license:
			'https://agent.meibaokeji.com.cn/employer/business_license/20240424/56bf013f-29ca-42b5-8c35-eda4ea169fdc.jpg',
	},
	{
		unit_name: '吉林市吉纤水泥有限公司',
		unit_code: '91220294724852479Q',
		area_code: '220221',
		bus_license: 'https://www.boweibx.com/employer/business_license/20240424/79153020-d1b5-4d9d-8398-6c64347bb94a.jpg',
	},
	{
		unit_name: '常州市三生机械有限公司',
		unit_code: '91320411313936985X',
		area_code: '320411',
		bus_license: 'https://www.boweibx.com/employer/business_license/20230914/f9b07692-20e8-462a-a5fd-af3fe1fb3471.jpg',
	},
	{
		unit_name: '襄阳亚投机械有限公司',
		unit_code: '91420625MA49544KXP',
		area_code: '420625',
		bus_license:
			'https://agent.meibaokeji.com.cn/employer/business_license/20220420/3129e7c7-8075-4455-b646-715a6ff5149f.jpg',
	},
	{
		unit_name: '湖北颐达通环保设备有限公司',
		unit_code: '91420106MA4KX7YWXK',
		area_code: '420106',
		bus_license: 'https://www.boweibx.com/employer/business_license/20220610/53c92e7b-574c-44d1-a5da-781e347a414b.jpg',
	},
]

export function getMockEmpList() {
	return Random.pick(empList, 3)
}

export function getMockUnitData() {
	let tempUnitData = Mock.mock({
		sameUnit: true,
		legal_person: '@cname',
		legal_person_mobile: /^1(5|3|7|8)[0-9]{9}$/,
		unit_addr: '@county(true)',
	})
	return Object.assign(tempUnitData, Random.pick(unitList))
}

// Mock.mock('/dist/distProduct/listInfo', 'get', mockData)
